"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MarginBalancesTableContainer = void 0;
var _reactRedux = require("react-redux");
var _reselect = require("reselect");
var _MarginBalancesTable = require("./MarginBalancesTable");
var _selectors = require("../../../redux/margin/selectors");
var _productsSelectors = require("../../../redux/selectors/productsSelectors");
var filteredProductsSelector = (0, _reselect.createSelector)(_selectors.marginProductSelector, function (_, _ref) {
  var searchText = _ref.searchText;
  return searchText;
}, function (products, searchText) {
  return products.filter(function (p) {
    if (p.TotalAmountNotional <= 0 && p.isCollateralEnabled === false) {
      return false;
    }
    var product = (p === null || p === void 0 ? void 0 : p.ProductSymbol) || '';
    var productFullName = (p === null || p === void 0 ? void 0 : p.ProductFullName) || '';
    return product.toUpperCase().includes(searchText.toUpperCase()) || productFullName.toUpperCase().includes(searchText.toUpperCase());
  });
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    loading: state.apexCore.product.fetching || state.margin.balances.fetching || !state.margin.products.loaded,
    products: filteredProductsSelector(state, ownProps),
    baseAsset: (0, _productsSelectors.baseNotionalProductSymbolSelector)(state)
  };
};
var MarginBalancesTableContainer = exports.MarginBalancesTableContainer = (0, _reactRedux.connect)(mapStateToProps)(_MarginBalancesTable.MarginBalancesTable);